import React, { Component, PureComponent } from 'react'
import { Map, List, fromJS } from 'immutable'
import DataTable from '../datatable'
import { Link } from 'react-router-dom'
import { Icon, Popup } from 'semantic-ui-react'
import Form from './views/form'
import { EventLogItem } from '../event/log'

const opcos = {
  FI: 'FI',
  US: 'US',
  SE: 'SE',
  G: 'G',
}

const contactTypes = {
  free: 'Tullut markkinoinnista',
  course: 'Aloittanut kurssin',
}

export function ContactEvents({ events, icon }) {
  let popupContent = (
    <div className="contact-event-log">
      {events.map(event => (
        <EventLogItem event={event} key={event.get('id')} />
      ))}
    </div>
  )

  return (
    <div className="contact-status-item contact-status-item--events">
      <Popup
        trigger={
          <button className="tags-item tags-item--grey">
            <Icon name={icon} /> {events.size}
            {events.size > 4 ? '+' : ''}
          </button>
        }
        content={popupContent}
        style={{ marginTop: 0, padding: 0, borderRadius: 0 }}
        on="click"
        position="bottom center"
      />
    </div>
  )
}

const columns = [
  {
    name: 'name',
    label: 'Nimi',
    id: true,
    sortable: true,
  },
  {
    name: 'email',
    label: 'Sähköposti',
    sortable: true,
  },
  {
    name: 'organizations',
    label: 'Organisaatiot',
    render(row) {
      return row.get('organizations', List()).map(i => (
        <Link
          to={`/organization?editId=${i.get('id')}&search=${i.get('name')}`}
          className="tags-item tags-item--orange"
          key={i.get('id')}>
          {i.get('name')} ({i.get('operating_company_id')})
        </Link>
      ))
    },
  },
  // {
  //   name: 'projects',
  //   label: 'Projektit',
  //   render(row) {
  //     return row.get('projects', List())
  //       .map(i => (
  //         <Link to={ `/project/${i.get('id')}` }
  //           className="tags-item tags-item--orange"
  //           key={ i.get('id') }>
  //           { i.get('name') }
  //         </Link>
  //         ))
  //   }
  // },
  // {
  //   name: 'interviews',
  //   label: 'Haastattelut',
  //   render(row) {
  //     return row.get('interviews', List())
  //       .map(i => (
  //         <Link to={ `/project/${i.get('project_id')}/interview/${i.get('id')}` }
  //           className="tags-item tags-item--blue"
  //           key={ i.get('id') }>
  //           { i.get('name') }
  //         </Link>
  //         ))
  //   }
  // },
  // {
  //   name: 'orders',
  //   label: 'Tilaukset',
  //   render(row) {
  //     return row.get('orders', List())
  //       .map(i => (
  //         <Link to={ `/order?editId=${i.get('id')}` }
  //           className="tags-item tags-item--purple"
  //           key={ i.get('id') }>
  //           <Icon name="file text" />
  //           { i.get('name') }
  //         </Link>
  //         ))
  //   }
  // },
  /*{
    name: 'events',
    label: 'Tapahtumat',
    render(row) {
      return (
        <div className="contact-status">
          <ContactEvents events={ row.get('normalEvents', List()) } icon="bell" />
          <ContactEvents events={ row.get('loginEvents', List()) } icon="rss" />
        </div>
      )
    }
  },*/
  {
    name: 'created_at',
    label: 'Luotu',
    date: 'DD.MM.YYYY - HH:mm',
    width: 200,
    sortable: true,
    defaultSort: true,
  },
]

const filterFields = [
  {
    type: 'group',
    placeholder: 'OPCO',
    icon: 'building',
    fields: [
      {
        name: 'operating_company_id',
        type: 'checkboxes',
        label: 'OPCO',
        options: Object.keys(opcos).map(key => ({ value: key, label: opcos[key] })),
      },
    ],
  },
  {
    name: 'type',
    type: 'buttons',
    label: 'Tyyppi',
    multiple: true,
    options: Object.keys(contactTypes).map(k => ({
      value: k,
      label: contactTypes[k],
    })),
  },
]

export default function ContactRoot() {
  return (
    <DataTable
      id="contacts"
      entity="contact"
      crud
      title="Yhteyshenkilöt"
      apiPath="/contact-event"
      editComponent={props => (
        <Form {...props} prefix={props.itemId + '.'} actions contact={props.formState.values.get(props.itemId)} />
      )}
      filters
      filterFields={filterFields}
      columns={columns}
      editWide
    />
  )
}
